export default __webpack_public_path__ + "static/media/fast-food.54a97615.png";